import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ManagerService } from "../../core/services/manager.service";
import { filter, map, shareReplay } from "rxjs/operators";

@Component({
  selector: "app-leaderboard",
  templateUrl: "./leaderboard.component.html",
  styleUrls: ["./leaderboard.component.scss"],
})
export class LeaderboardComponent {
  url$ = this.managerService.skinsSettings$.pipe(
    filter((skinSettings) => this.hasLeaderboardUrl(skinSettings)),
    map((skinSettings) =>
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        skinSettings.leaderboardLink.trim(),
      ),
    ),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(
    private managerService: ManagerService,
    private domSanitizer: DomSanitizer,
  ) {}

  private hasLeaderboardUrl(skinSettings: any): boolean {
    const url = skinSettings?.leaderboardLink;
    return typeof url === "string" && url.trim().length > 0;
  }
}
